import { getTemplateNavHeaderStyles } from './NavHeader.styles'
import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'

const t = document.createElement('template')
t.innerHTML = `
<wa-details exportparts="base,header,summary,content,icon" class="contextual-dropdown-item">
  <slot></slot>
</wa-details>
`

class NavHeaderMobilePrimaryMenu extends HTMLElement {
  private waDetails: HTMLElement | null = null

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Details])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    this.waDetails = shadow.querySelector('wa-details')
  }

  connectedCallback() {
    // Forward all attributes to wa-details
    if (this.waDetails) {
      for (const attr of this.attributes) {
        this.waDetails.setAttribute(attr.name, attr.value)
      }

    }
  }
}

customElements.define('ts-navheader-mobile-primary-menu', NavHeaderMobilePrimaryMenu)
